import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./ExternalModerator.css";
import EnhancedTable from '../../widgets/Table';
import EnhancedToolbar from '../../widgets/Toolbar';
import ExternalModeratorSearchForm from './ExternalModeratorSearchForm';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

const headCells = [
    { id: 'FirstName', numeric: false, disablePadding: true, label: 'First Name' },
    { id: 'MiddleName', numeric: false, disablePadding: true, label: 'Middle Name' },
    { id: 'Surname', numeric: false, disablePadding: true, label: 'Surname' },
    { id: 'IDNo', numeric: false, disablePadding: true, label: 'ID Number' }

];

const toolbarButtons = [
    { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon' },
    { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon' }
];

const handler = (state) => {
    return {
        //isLoading: state.learner.isLoading,
        //message: state.learner.message
    };
};

class ExternalModeratorSearch extends Component {

    state = {
        model: {},
        searchParameters: [{ Name: "FirstName", Value: "" },
                           { Name: "MiddleName", Value: "" },
                           { Name: "Surname", Value: "" },
                           { Name: "IDNo", Value: "" }
        ],
        selection: []
    };

    handleToolbarButtonClick(buttonId) {
        if ("add" === buttonId) {
            this.props.history.push('/external-moderator');
        } else {
            this.props.history.push({
                pathname: '/external-moderator',
                state: { selection: this.state.selection[0] }
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.message !== this.props.message && this.props.message) {
            this.setState({ message: this.props.message });
        }
    }
    
    search() {
        this.setState({
            searchParameters: [{ Name: "FirstName", Value: this.state.model.firstName },
            { Name: "MiddleName", Value: this.state.model.middleName },
            { Name: "Surname", Value: this.state.model.surname },
            { Name: "IDNo", Value: this.state.model.idNumber }           
            ]
        });
    }

    render() {
        return (
            <div className="view w-100 h-100">
                <p className="legend">
                   External Moderators
                </p>
                <p className="message">
                    {this.state.message}
                </p>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <ExternalModeratorSearchForm model={this.state.model} />
                            </td>
                            <td>
                                <IconButton
                                    onClick={this.search.bind(this)}
                                    aria-label="search">
                                    <SearchIcon />
                                </IconButton>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="searchResults">
                    <EnhancedToolbar highlight={false} title="Employers" buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)} enabled={typeof this.state.selection !== 'undefined' && this.state.selection !== null && this.state.selection.length > 0} buttons={toolbarButtons}/>
                    <EnhancedTable headCells={headCells} onSelectionChange={(selection) => this.setState({ selection: selection})}
                        dataUrl="api/indicium/moderator/search" paged={false}
                        searchParameters={this.state.searchParameters} />
                </div>
            </div>
        );
    }
}

export default withRouter(
    connect()(ExternalModeratorSearch)
);
